import React, { useCallback, useContext } from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FormFieldError from '../FormFieldError';
import Alerts from './components/Alerts';
import ImageSelector from './components/ImageSelector';
import Select from './components/Select';
import Gallery from './components/Gallery';
import { ImageContext } from './store';
import classNames from 'classnames';

const getUrlFromImageAsset = (image) => `/preview/asset/${image.id}?instanceName=sandbox`;
const FormImageComponent = (props) => {
  const {
    label,
    isRequired,
    fieldError,
    className: providedClassName,
    uploadButtonText,
    useCropper,
    croppedRatio,
    images,
    formContext,
  } = props;
  const { open } = useContext(ImageContext);
  const onClick = useCallback(
    (e) => {
      e.preventDefault();
      // Unset selectedAssetId when using upload button
      formContext?.setValue('selectedAssetId', '', { shouldDirty: true });
      open();
    },
    [open, formContext]
  );

  const selectedAssetId = formContext?.watch('selectedAssetId');
  const selectedAssetImage = selectedAssetId
    ? images.find((image) => image.id === selectedAssetId)
    : null;
  return (
    <div
      className={classNames(providedClassName, {
        'has-error': !!fieldError,
      })}
    >
      <Typography fontWeight={800}>
        {label}
        {isRequired && <span style={{ color: 'red' }}>*</span>}
      </Typography>

      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            {selectedAssetImage ? (
              <div style={{ display: 'flex', height: '200px' }}>
                <img src={getUrlFromImageAsset(selectedAssetImage)} />
              </div>
            ) : (
              <ImageSelector useCropper={useCropper} croppedRatio={croppedRatio} />
            )}
          </Grid>
          <Grid item xs={12} sm={6} md={8} justifyContent="flex-start">
            <Gallery images={images} formContext={formContext} fieldName={'selectedAssetId'} />
            <Select formContext={formContext} fieldName={'selectedAssetId'} />
            <Button
              variant="contained"
              color="primary"
              onClick={onClick}
              style={{ marginTop: '10px', width: '200px' }}
            >
              {uploadButtonText ? uploadButtonText : 'Upload'}
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Alerts />
          </Grid>
        </Grid>
      </Box>
      <FormFieldError error={fieldError} />
    </div>
  );
};

export default FormImageComponent;
